import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "shakatah-cookie-consent";

// NOTE: Using function declaration instead of const arrow to prevent TDZ errors in production builds
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-40 max-w-sm animate-in slide-in-from-left-5 duration-300">
      <div className="bg-card border border-border rounded-lg shadow-lg p-4 relative">
        <button
          onClick={handleDecline}
          className="absolute top-2 right-2 text-muted-foreground hover:text-foreground"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3 pr-6">
          <Cookie className="w-5 h-5 text-primary shrink-0 mt-0.5" />
          <div className="space-y-2">
            <p className="text-sm text-foreground font-medium">We use cookies</p>
            <p className="text-xs text-muted-foreground">
              We use cookies to improve your experience.{" "}
              <Link to="/privacy-policy" className="text-primary hover:underline">
                Learn more
              </Link>
            </p>
            <div className="flex items-center gap-2 pt-1">
              <Button variant="outline" size="sm" onClick={handleDecline} className="h-7 text-xs px-3">
                Decline
              </Button>
              <Button size="sm" onClick={handleAccept} className="h-7 text-xs px-3">
                Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
